import React from 'react';
import MirrorForm from '../mirror/MirrorForm';
import { MirrorPage } from '../mirror/MirrorPage';

/* ────────────────────────────────────────────────────────────
 * Outgoing - Sales > Stories & Updates > Create — traced from the
 * native app's CompletedAction/CreateStoriesAndUpdate.js ("Stories And
 * Updates": Title, Attachment (image or video) with an Attachment
 * Preview, SUBMIT; native alerts when the title is empty and posts a
 * multipart body to GET_STORIESANDUPDATES). UI only here.
 * ──────────────────────────────────────────────────────────── */

const FIELDS = [
  { name: 'title', label: 'Title', required: true, placeholder: 'Enter Title' },
  { name: 'attachment', label: 'Attachment', type: 'file', accept: 'image/*,video/*', hint: 'Choose an image or video' },
];

export default function StoryCreateScreen() {
  return (
    <MirrorPage title="Stories And Updates" subtitle="Create story">
      <MirrorForm fields={FIELDS} submitLabel="Submit" successMessage="Story saved — not sent to an endpoint yet." />
    </MirrorPage>
  );
}
